export const REQUEST_TYPE = {
    LATE_COMING: "LATE_COMING",
    LEAVE_EARLY: "LEAVE_EARLY",
    FORGOT_CHECK_IN: "FORGOT_CHECK_IN",
    FORGOT_CHECK_OUT: "FORGOT_CHECK_OUT",
    ANNUAL_LEAVE: "ANNUAL_LEAVE",
    SICK_LEAVE: "SICK_LEAVE",
    MARRIAGE_LEAVE: "MARRIAGE_LEAVE",
    BEREAVEMENT_LEAVE: "BEREAVEMENT_LEAVE",
    UNPAID_LEAVE: "UNPAID_LEAVE",
    BUSINESS_TRAVEL: "BUSINESS_TRAVEL",
    OVERTIME: "OVERTIME",
    PART_TIME: "PART_TIME"
}

export const APPROVAL_REQUEST_MENU_TYPE = {
    MY_REQUEST: "MY_REQUEST",
    MANAGER: "MANAGER",
    HR: "HR"
}
